var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import axios from "axios";
var csrfTokenEndpoint = "".concat(document.location.protocol, "//").concat(document.location.host, "/store/token/get");
var sessionWindow = window;
var csrfTokenRefreshRequest = null;
var isCateringOrder = function () {
    var _a, _b;
    return ((_b = (_a = sessionWindow.session) === null || _a === void 0 ? void 0 : _a.store) === null || _b === void 0 ? void 0 : _b.is_catering) === true;
};
var getCurrentCsrfToken = function () {
    var _a;
    return (_a = sessionWindow.session) === null || _a === void 0 ? void 0 : _a.token;
};
var setCurrentCsrfToken = function (token) {
    sessionWindow.session.token = token;
};
var getRequestHeaders = function (headers) {
    return __assign(__assign(__assign({ credentials: "same-origin", "Content-Type": "application/json", Accept: "application/json", "X-Requested-With": "XMLHttpRequest" }, (isCateringOrder() ? { "X-Vivid-Order-Mode": "catering" } : {})), (headers !== null && headers !== void 0 ? headers : {})), { "X-CSRF-TOKEN": getCurrentCsrfToken() });
};
var refreshCsrfToken = function () { return __awaiter(void 0, void 0, Promise, function () {
    var refreshRequest;
    return __generator(this, function (_a) {
        if (!csrfTokenRefreshRequest) {
            refreshRequest = axios
                .get(csrfTokenEndpoint, {
                withCredentials: true,
                headers: {
                    Accept: "text/plain, application/json",
                    "X-Requested-With": "XMLHttpRequest",
                },
            })
                .then(function (response) {
                var token = response.data;
                if (typeof token !== "string" || token.length === 0) {
                    throw new Error("Unable to refresh CSRF token.");
                }
                setCurrentCsrfToken(token);
                return token;
            });
            csrfTokenRefreshRequest = refreshRequest.then(function (token) {
                csrfTokenRefreshRequest = null;
                return token;
            }, function (error) {
                csrfTokenRefreshRequest = null;
                throw error;
            });
        }
        return [2 /*return*/, csrfTokenRefreshRequest];
    });
}); };
var client = axios.create({
    baseURL: "".concat(document.location.protocol, "//").concat(sessionWindow.session.store.fqdn, "/").concat(sessionWindow.session.store.urlslug),
    withCredentials: true,
});
client.interceptors.request.use(function (config) {
    return __assign(__assign({}, config), { headers: getRequestHeaders(config.headers) });
});
client.interceptors.response.use(function (response) { return response; }, function (error) { return __awaiter(void 0, void 0, void 0, function () {
    var originalRequest;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                originalRequest = error.config;
                if (((_a = error.response) === null || _a === void 0 ? void 0 : _a.status) !== 419 || !originalRequest || originalRequest.hasRetriedWithFreshCsrfToken) {
                    return [2 /*return*/, Promise.reject(error)];
                }
                originalRequest.hasRetriedWithFreshCsrfToken = true;
                return [4 /*yield*/, refreshCsrfToken()];
            case 1:
                _b.sent();
                return [2 /*return*/, client.request(originalRequest)];
        }
    });
}); });
var get = function (end, config) {
    return client.get(end, config);
};
var post = function (end, data, config) {
    return client.post(end, data, config);
};
var patch = function (end, data, config) {
    return client.patch(end, data, config);
};
var del = function (end, config) {
    return client.delete(end, config);
};
export default {
    get: get,
    post: post,
    patch: patch,
    delete: del,
};
